import React from 'react'
import useProfileContacts from './profileContacts-hook';
import { generateContactLink } from '../../../../../../../Utilits/utilits';
import { IEditBusinessProfileMainProps } from '../ProfileMain/profileMainInfo';
import useLanguagesHooks from '../../../../../../../Components/Languages/setLanguage-hooks';
import CustomDialog from '../../../../../../../Components/Dialog/customDialog';
import Button from '../../../../../../../Components/Button/button';
import { ButtonTypes, ContactLinkTypes} from '../../../../../../../Interfaces/componentTypes';
import { Edit, OpenSvg, SmallTrash } from '../../../../../../../Assets/Icons';
import styles from './contacts.module.scss';

const BusinessContacts: React.FC<IEditBusinessProfileMainProps> = (props) => {
    const { t } = useLanguagesHooks();
    const {
        open,
        isChanged,
        isLoading,
        filledContacts,
        profileContacts,
        dialogComponent,
        onOpenContactDialog,
        onCloseContactDialog,
        handleDeleteContact,
        handleSubmitContacts,
    } = useProfileContacts(props);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <p>
                    {t('My_Business.Business_Profile.Contact.Header')}
                </p>
            </div>
            <div className={styles.body}>
                <div className={styles.contacts}>
                    <div className={styles.contactsHeader}>
                        <div>
                        <p>{t('My_Business.Business_Profile.Contact.Select')}</p>
                        </div>
                    </div>
                    <div className={styles.contactsRow}>
                        {
                            profileContacts.map((item) => {
                                return (
                                    <div
                                        key={item.id}
                                        className={styles.contactItem}
                                        onClick={() => onOpenContactDialog(item)}>
                                        <img src={item.icon} alt={`${item.id}.svg`} />
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                {filledContacts.length > 0 && (
                    <div className={styles.filledContacts}>
                        <div className={styles.filledContactsHeader}>
                            <div />
                            <p>{t("My_Business.Business_Profile.Contact.Filled_Header")}</p>
                            <div />
                        </div>
                        <div className={styles.filledContactsList}>
                            {filledContacts.map(contact => {
                                const contactLink = generateContactLink(contact?.id as ContactLinkTypes, contact?.value!);
                                return (
                                    <div key={contact?.id} className={styles.filledContactItem}>
                                        <div className={styles.link}>
                                            <img src={contact?.icon} alt={`${contact?.id}.svg`} />
                                            <p>{contact?.value}</p>
                                        </div>
                                        <div className={styles.actionRow}>
                                            <img
                                                src={Edit}
                                                alt='edit.svg'
                                                className={styles.actioItem}
                                                onClick={() => onOpenContactDialog(contact!)}
                                            />
                                            {contact?.id !== 'phone_numbers' && contactLink && (
                                                <a
                                                    href={contactLink?.fallback}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className={styles.linkWrapper}
                                                >
                                                    <img
                                                        src={OpenSvg}
                                                        alt="view.svg"
                                                        className={styles.actioItem}
                                                    />
                                                </a>
                                            )}
                                            <img
                                                src={SmallTrash}
                                                alt='cardTras.svg'
                                                className={styles.actioItem}
                                                onClick={() => handleDeleteContact(contact?.id!)}
                                            />
                                        </div>
                                    </div>
                                )

                            })}
                        </div>
                    </div>
                )}
                {isChanged
                    &&
                    <Button
                        buttonType={ButtonTypes.Primery}
                        onClick={handleSubmitContacts}
                        title={t('Buttons.Save')}
                        buttonStyle={styles.button}
                        isLoading={isLoading}
                    />
                }
            </div>
            <CustomDialog
                open={open}
                onClose={onCloseContactDialog}
                children={dialogComponent}
            />
        </div>
    )
}

export default BusinessContacts
